export default __webpack_public_path__ + "static/media/about-us-banner.fd19ff0c.png";